import { Link } from "react-router-dom";
import { useTranslation } from "@/components/LanguageContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/p3s982cv_1.jpg";

export default function FooterSection() {
  const { t } = useTranslation();
  const footerLinks = {
    [t("footer.platform")]: [
      { label: "Módulos", href: "#" }, { label: "Simulados", href: "#" }, { label: "Analytics", href: "#" }, { label: "Mobile App", href: "#" },
    ],
    [t("footer.company")]: [
      { label: t("nav.about"), href: "/#sobre" }, { label: t("nav.partnerships"), href: "/#parcerias" }, { label: "Carreiras", href: "#" }, { label: "Blog", href: "#" },
    ],
    [t("footer.legal")]: [
      { label: t("footer.privacy"), href: "/privacy-policy" }, { label: "Termos", href: "#" }, { label: "Cookies", href: "#" }, { label: "RGPD", href: "/privacy-policy" },
    ],
  };

  return (
    <footer className="bg-[#020518] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="h-14 w-14 rounded-xl overflow-hidden bg-[#0A1628] ring-1 ring-[#00A8FF]/20 shrink-0">
                <img src={LOGO_URL} alt="L4C" className="w-full h-full object-cover" />
              </div>
              <div className="leading-tight">
                <span className="font-['Outfit'] font-bold text-sm text-white block">L4C Aviation Academy</span>
                <span className="text-[10px] font-semibold tracking-[0.15em] uppercase text-[#00A8FF]">EASA Part 66</span>
              </div>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed mb-6">{t("footer.desc")}</p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-4 font-['Outfit']">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((item) => {
                  const isInternal = item.href.startsWith("/") && !item.href.startsWith("//");
                  if (isInternal && !item.href.startsWith("/#")) {
                    return <li key={item.label}><Link to={item.href} className="text-sm text-slate-500 hover:text-white transition-colors duration-200">{item.label}</Link></li>;
                  }
                  return <li key={item.label}><a href={item.href} className="text-sm text-slate-500 hover:text-white transition-colors duration-200">{item.label}</a></li>;
                })}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-600">&copy; 2026 L4C Aviation Academy. {t("footer.rights")}</p>
          <p className="text-xs text-slate-600">EASA Part 66 &middot; Portugal</p>
        </div>
      </div>
    </footer>
  );
}
